The position opening that the candidate is associated with.
